import React from 'react'

const Medication = () => {
  return (
    <svg
      aria-hidden="true"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 0.416748H4.16667C3.93655 0.416748 3.75 0.603296 3.75 0.833415V3.33341C3.75 3.56353 3.93655 3.75008 4.16667 3.75008H15.8333C16.0635 3.75008 16.25 3.56353 16.25 3.33341V0.833415C16.25 0.603296 16.0635 0.416748 15.8333 0.416748Z"
        fill="white"
      />
      <path
        d="M13.3333 7.31042V4.375H6.66667V7.31042C5.52845 7.41575 4.47051 7.94203 3.69987 8.78626C2.92923 9.6305 2.50136 10.7319 2.5 11.875V17.2917C2.50066 17.844 2.72037 18.3735 3.11092 18.7641C3.50148 19.1546 4.031 19.3743 4.58333 19.375H15.4167C15.969 19.3743 16.4985 19.1546 16.8891 18.7641C17.2796 18.3735 17.4993 17.844 17.5 17.2917V11.875C17.4986 10.7319 17.0708 9.6305 16.3001 8.78626C15.5295 7.94203 14.4715 7.41575 13.3333 7.31042ZM12.0833 13.5417H10.4167V15.2083C10.4167 15.3188 10.3728 15.4248 10.2946 15.503C10.2165 15.5811 10.1105 15.625 10 15.625C9.88949 15.625 9.78351 15.5811 9.70537 15.503C9.62723 15.4248 9.58333 15.3188 9.58333 15.2083V13.5417H7.91667C7.80616 13.5417 7.70018 13.4978 7.62204 13.4196C7.5439 13.3415 7.5 13.2355 7.5 13.125C7.5 13.0145 7.5439 12.9085 7.62204 12.8304C7.70018 12.7522 7.80616 12.7083 7.91667 12.7083H9.58333V11.0417C9.58333 10.9312 9.62723 10.8252 9.70537 10.747C9.78351 10.6689 9.88949 10.625 10 10.625C10.1105 10.625 10.2165 10.6689 10.2946 10.747C10.3728 10.8252 10.4167 10.9312 10.4167 11.0417V12.7083H12.0833C12.1938 12.7083 12.2998 12.7522 12.378 12.8304C12.4561 12.9085 12.5 13.0145 12.5 13.125C12.5 13.2355 12.4561 13.3415 12.378 13.4196C12.2998 13.4978 12.1938 13.5417 12.0833 13.5417Z"
        fill="white"
      />
    </svg>
  )
}

export default Medication
